// ImpressumPage: Legal notice page (§ 5 DDG) — publicly accessible without login.
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import './LegalPage.css';

export default function ImpressumPage() {
  const navigate = useNavigate();

  const contactName = process.env.REACT_APP_CONTACT_NAME || '[DEIN VOLLSTÄNDIGER NAME]';
  const contactName2 = process.env.REACT_APP_CONTACT_NAME2 || '[ZWEITER NAME ODER FIRMA]';
  const contactStreet = process.env.REACT_APP_CONTACT_STREET || '[STRASSE UND HAUSNUMMER]';
  const contactCity = process.env.REACT_APP_CONTACT_CITY || '[PLZ ORT]';
  const contactEmail = process.env.REACT_APP_CONTACT_EMAIL || '[DEINE-EMAIL@EXAMPLE.DE]';

  return (
    <div className="legal-page">
      <div className="legal-page__content">
        <button
          className="legal-page__back"
          onClick={() => navigate(-1)}
          style={{ background: 'none', border: 'none', cursor: 'pointer' }}
        >
          <ArrowLeft size={16} /> Zurück
        </button>

        <h1>Impressum</h1>
        <p className="legal-page__updated">Stand: Februar 2026</p>

        <address className="legal-page__address">
          {contactName}<br />
          {contactName2}<br />
          {contactStreet}<br />
          {contactCity}
        </address>

        <h2>Kontakt</h2>
        <p>
          E-Mail: <a href={`mailto:${contactEmail}`}>{contactEmail}</a><br />
          Kontaktformular: <Link to="/kontakt">Öffnen</Link>
        </p>

        <h2>Haftung für Inhalte</h2>
        <p>
          Als Diensteanbieter bin ich gemäß § 7 Abs. 1 DDG für eigene Inhalte auf
          diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis
          10 DDG bin ich als Diensteanbieter jedoch nicht verpflichtet, übermittelte
          oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu
          forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
        </p>
        <p>
          Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen
          nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche
          Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten
          Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden
          Rechtsverletzungen werde ich diese Inhalte umgehend entfernen.
        </p>

        <h2>Haftung für Links</h2>
        <p>
          Dieses Angebot enthält Links zu externen Websites Dritter, auf deren
          Inhalte ich keinen Einfluss habe. Deshalb kann ich für diese fremden
          Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten
          Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten
          verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung
          auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum
          Zeitpunkt der Verlinkung nicht erkennbar.
        </p>
        <p>
          Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne
          konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei
          Bekanntwerden von Rechtsverletzungen werde ich derartige Links umgehend
          entfernen.
        </p>

        <h2>Urheberrecht</h2>
        <p>
          Die durch den Seitenbetreiber erstellten Inhalte und Werke auf diesen
          Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung,
          Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen
          des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen
          Autors bzw. Erstellers.
        </p>

        <h2>Streitschlichtung</h2>
        <p>
          Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung
          (OS) bereit:{' '}
          <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer">
            https://ec.europa.eu/consumers/odr
          </a>.
        </p>
        <p>
          Ich bin nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor
          einer Verbraucherschlichtungsstelle teilzunehmen.
        </p>

        <div className="legal-page__disclaimer">
          <p>
            <strong>Scryfall</strong><br />
            Kartendaten und -bilder werden von{' '}
            <a href="https://scryfall.com" target="_blank" rel="noopener noreferrer">
              Scryfall
            </a>{' '}
            bereitgestellt. Diese Website ist nicht mit Scryfall affiliiert.
          </p>
          <p>
            <strong>Wizards of the Coast</strong><br />
            Magic: The Gathering ist ein eingetragenes Warenzeichen von Wizards of
            the Coast / Hasbro, Inc. Diese Seite ist inoffizieller Fan Content und
            wurde nicht von Wizards of the Coast genehmigt oder unterstützt. Teile
            der verwendeten Materialien sind Eigentum von Wizards of the Coast.
            Weitere Informationen:{' '}
            <a
              href="https://company.wizards.com/en/legal/fancontentpolicy"
              target="_blank"
              rel="noopener noreferrer"
            >
              Fan Content Policy
            </a>.
          </p>
        </div>

        <p style={{ marginTop: '24px', fontSize: 'var(--text-xs)', color: 'var(--text-muted)' }}>
          Siehe auch: <Link to="/datenschutz">Datenschutzerklärung</Link>
        </p>
      </div>
    </div>
  );
}
